import React from 'react';
import classes from './Button.module.css'

const Button = (props) => {
  const { children,className, ...restProps } = props;

  return (
    <button className={classes['button'] + ' ' + className} {...restProps}>
      {children}
    </button>
  );
};

export default Button;
